import React from 'react'

import PropTypes from 'prop-types'

import './fale-comigo.css'

const FaleComigo = (props) => {
  return (
    <div className={`fale-comigo-frame89 ${props.rootClassName} `}>
      <div className="fale-comigo-frame81">
        <span className="fale-comigo-text1">
          <span>Fale Comigo</span>
        </span>
        <span className="fale-comigo-text3">
          <span>
            Vamos construir uma conexão mais próxima. Compartilhe um resumo do
            seu caso e, em breve, estaremos em contato. Seu tempo é valioso, e
            nossa promessa é responder prontamente. Estamos aqui para ouvir,
            entender e agir. Juntos, vamos moldar a estratégia que melhor atende
            às suas necessidades legais.
          </span>
        </span>
      </div>
      <iframe
        src="https://whc-dun.vercel.app/email"
        className="fale-comigo-iframe"
        scrolling="no"
      ></iframe>
    </div>
  )
}

FaleComigo.defaultProps = {
  rootClassName: '',
}

FaleComigo.propTypes = {
  rootClassName: PropTypes.string,
}

export default FaleComigo
